/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import { Link, useNavigate } from "react-router-dom";
import { GO_TO_DASHBOARDS } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { Pencil, Trash2, GanttChartSquare } from "lucide-react";
// import FullDataTable from "../../../../Components/ExtraComponents/Datatable/FullDataTable"
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

import BasicDataTable from "../../../../Components/ExtraComponents/Datatable/BasicDataTable";
import { GET_ALL_GROUP_SERVICES } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import {
  GET_ALL_SERVICES_NAMES,
  DELETE_GROUP_SERVICE,
  Get_client_By_strategy_Id,
  GET_ALL_SERVICES_USER_NAMES,
} from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../Components/ExtraComponents/Modal";
import toast, { Toaster } from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import Swal from "sweetalert2";
import { GetSubadmingroupServices } from "../../../../Service/admin.service";

const ServicesList = () => {
  const Subadminpermission = JSON.parse(
    localStorage.getItem("subadminpermission")
  );
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [first, setfirst] = useState("all");
  const [showModal, setshowModal] = useState(false);
  const [showModaluser, setshowModaluser] = useState(false);
  const [showDeletModal, setShowDeletModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [test, settest] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [getServicesName, setServicesName] = useState({
    loading: true,
    data: [],
  });
  

    const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const [getServicesuserName, setServicesuserName] = useState([]);
  const [AllGroupServices, setAllGroupServices] = useState({
    loading: true,
    data: [],
  });

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    data();
    setSearchInput("");
  }, [refresh]);

  useEffect(() => {
    const filteredData = originalData.filter((item) => {
      return item?.name?.toLowerCase().includes(searchInput?.toLowerCase());
    });
    setAllGroupServices({
      loading: false,
      data: searchInput ? filteredData : originalData,
    });
  }, [searchInput, originalData]);

    

  const columns = [
    {
      name: "Group Services Name",
      selector: (row) => row.name,
      cell: (row) => <div>{row.name || "-"}</div>,
      sortable: true,
    },
    {
      name: "Service Count",
      selector: (row) => row.resultCount,
      cell: (row) => <div>{row.resultCount || "-"}</div>,
      sortable: true,
    },
    {
      name: "Services/Client",
      selector: (row) => row.categoryResult?.segment,
      cell: (row) => (
        <div>
          <GanttChartSquare
            onClick={() => GetAllServicesName(row)}
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
          />
          {/* <GanttChartSquare
            onClick={() => GetAllServicesUserName(row)}
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
          /> */}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Actions",
      selector: () => null,
      cell: (row) => (
        <div>
          <Link to={`/subadmin/groupservices/edit/${row._id}`} title="Edit">
            <Pencil
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
            />
          </Link>
          <span title="Delete">
            <Trash2
              size={20}
              color="#d83131"
              strokeWidth={2}
              className="mx-1"
              onClick={() => DeleteGroup(row)}
            />
          </span>
        </div>
      ),
      sortable: false,
    },

    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1">
          <span>{new Date(row?.createdAt).toLocaleString() || "-"}</span>
        </div>
      ),
      sortable: true,
    },
    // {
    //     name: "updatedAt",
    //     selector: (row) => row.updatedAt,
    //     cell: (row) => (
    //         <div className="d-flex align-items-center gap-1">
    //             <span>{new Date(row?.updatedAt).toLocaleString() || "-"}</span>

    //         </div>
    //     ),
    //     sortable: true,

    // }
  ];
  const columns1 = [
    {
      name: "Services Name",
      selector: (row) => row.data?.name || "-",
      sortable: true,
    },
    {
      name: "Group Qty",
      selector: (row) => row.data1?.group_qty || "-",
      sortable: true,
    },
  ];

  const columns2 = [
    {
      name: "User Name",
      selector: (row) => row.user?.FullName || "-",
      sortable: true,
    },
    {
      name: "Go To Dashboard",
      selector: (row) => row.user?.TradingStatus,
      cell: (row) => (
        <button
          className={`btn ${row.user?.AppLoginStatus == "1" || row.user?.WebLoginStatus == "1"
            ? "btn-success"
            : "btn-danger"
            } btn-new-block`}
          onClick={() => goToDashboard(row)}
          disabled={
            row.user?.AppLoginStatus === "0" && row.user?.WebLoginStatus === "0"
          }
        >
          click
        </button>
      ),
      sortable: false,
    },
    {
      name: "License Type",
      selector: (row) => row.user?.license_type,
      cell: (row) =>
        row.user?.license_type === "2"
          ? "Live"
          : row.user?.license_type === "1"
            ? "Demo"
            : "2 Days Only",
      sortable: true,
    },
  ];

  const GetAllServicesName = async (row) => {
    setshowModal(true);
    await dispatch(
      GET_ALL_SERVICES_NAMES({
        data: row,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setServicesName({
            loading: false,
            data: response.data,
          });
        } else {
          setServicesName({
            loading: false,
            data: [],
          });
        }
      });
  };

  const GetAllServicesUserName = async (row) => {
    await dispatch(
      GET_ALL_SERVICES_USER_NAMES({
        _id: row._id,
      })
    )
      .unwrap()
      .then((response) => {
        settest(true);
        if (response.status) {
          setServicesuserName({
            loading: false,
            data: response.data,
          });
        } else {
          setServicesuserName({
            loading: false,
            data: [],
          });
        }
      });
  };

  // GO TO  CLIENT  DASHBOARD
  const goToDashboard = async (email) => {
    let req = {
      Email: email.user.Email,
    };
    await dispatch(GO_TO_DASHBOARDS(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          localStorage.setItem("gotodashboard", JSON.stringify(true));
          localStorage.setItem(
            "user_details_goTo",
            JSON.stringify(response.data)
          );
          localStorage.setItem(
            "user_role_goTo",
            JSON.stringify(response.data.Role)
          );
          localStorage.setItem("page", "groupservices");

          navigate("/client/dashboard");
        }
      });
  };

  const DeleteGroup = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this group service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row._id };
        try {
          const response = await dispatch(DELETE_GROUP_SERVICE(req)).unwrap();
          if (response.status) {
            toast.success(response.msg);
            setrefresh(!refresh);
            Swal.fire("Deleted!", "Group service has been deleted.", "success");
          } else {
            toast.error(response.msg || "Failed to delete.");
          }
        } catch (err) {
          toast.error("Something went wrong.");
        }
      }
    });
  };

  const data = async () => {
    setIsLoading(true);
    const data = { userid: isgotodashboard ? gotodashboard.user_id : user_details.user_id };
    await GetSubadmingroupServices(data).then((response) => {
      if (response.status) {
        setAllGroupServices({
          loading: false,
          data: response.data,
        });
        setOriginalData(response.data);
      } else {
        setAllGroupServices({
          loading: false,
          data: response.data,
        });
      }
    }).finally(() => {
      setIsLoading(false);
    });

  };

  const handleReset = () => {
    setSearchInput("");
    setAllGroupServices({
      loading: false,
      data: originalData,
    });
  };


  return AllGroupServices.loading ? (
    <Loader />
  ) : (
    <>
      <Content
        Page_title="Group Service"
        button_title="Add Group"
        route="/subadmin/groupservices/add"
        button_status={Subadminpermission?.stock_group_service == 1 && !isgotodashboard && true}
      >
        <div className="mx-0 row filter-row mt-3 mt-md-0 ">
          <div className="col-lg-4 col-md-6 col-9 ps-0">
            <div className="mb-3">
              <input
                type="text"
                placeholder="Search..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="form-control"
                id="exampleFormControlInput1"
              />
            </div>
          </div>

          <div className="col-lg-2 col-3">
            <button
              className="btn btn-sm btn-primary "
              onClick={() => setrefresh((prev) => !prev)}
            >
              <i className="fa fa-refresh"></i>
            </button>
          </div>
        </div>

        {/* <FullDataTable TableColumns={columns} tableData={AllGroupServices.data} /> */}

        {isLoading ? (
          // Show loader in center
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Loader />
          </div>
        ) : (
          // Show table after data loads
          <Table columns={columns} data={AllGroupServices?.data || []} />
        )}


        {showModal ? (
          <>
            <Modal
              isOpen={showModal}
              backdrop="static"
              size="xxl"
              title="Services"
              hideBtn={true}
              // onHide={handleClose}
              handleClose={() => setshowModal(false)}
            >
              {/* <BasicDataTable TableColumns={[
                                                {
                                                    dataField: "index",
                                                    text: "SR. No.",
                                                    formatter: (cell, row, rowIndex) => rowIndex + 1,
                                                },
                                                {
                                                    dataField: 'data.name',
                                                    text: 'Services Name'
                                                },
                                                {
                                                    dataField: 'data1.group_qty',
                                                    text: 'group_qty'
                                                },
                                            ]} tableData={getServicesName && getServicesName.data} /> */}

              <Table
                columns={columns1}
                data={getServicesName && getServicesName.data}
              />
            </Modal>
          </>
        ) : (
          ""
        )}

        {test ? (
          <>
            <Modal
              isOpen={test}
              backdrop="static"
              size="xl"
              title="Clients Using"
              hideBtn={true}
              handleClose={() => settest(false)}
            >

              <Table
                columns={columns2}
                data={getServicesuserName && getServicesuserName?.data}
              />
            </Modal>
          </>
        ) : (
          ""
        )}

        {showDeletModal == true ? (
          <div
            className="modal custom-modal fade modal-delete"
            id="delete_modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content Anujjj">
                <div className="modal-body">
                  <div className="form-header">
                    <div className="delete-modal-icon">
                      <span>
                        <i className="fe fe-check-circle" />
                      </span>
                    </div>
                    <h3>Are You Sure?</h3>
                    <p>You want delete company</p>
                  </div>
                  <div className="modal-btn delete-action">
                    <div className="modal-footer justify-content-center p-0">
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="btn btn-primary paid-continue-btn me-2"
                      >
                        Yes, Delete
                      </button>
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn-back cancel-btn"
                      >
                        No, Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </Content>
      <ToastButton />
    </>
  );
};

export default ServicesList;
